import AsyncStorage from '@react-native-async-storage/async-storage';

export enum SnoozeType {
  Day,
  Shift,
}

export type CalendarSnoozeData = {
  type: SnoozeType;
  timestamp?: Date;
};

export class CalendarSnooze {
  private static buildKey(siteId: string, userId: string) {
    return `snooze:${siteId}:${userId}`;
  }

  static async get(siteId: string, userId: string): Promise<CalendarSnoozeData> {
    try {
      const value = await AsyncStorage.getItem(this.buildKey(siteId, userId));
      if (value) {
        const jsonData = JSON.parse(value);
        const snoozeType = jsonData.type ?? SnoozeType.Shift;
        return { type: snoozeType, timestamp: new Date(jsonData.timestamp) };
      }
      return { type: SnoozeType.Shift };
    } catch (error) {
      return { type: SnoozeType.Shift };
    }
  }

  static async set(siteId: string, userId: string, data: CalendarSnoozeData): Promise<void> {
    const jsonString = JSON.stringify({ type: data.type, timestamp: data.timestamp?.getTime() });
    await AsyncStorage.setItem(this.buildKey(siteId, userId), jsonString);
  }
}
